import Link from 'next/link'
import { SocialIcons } from '@/components/ui/social-icons'
import { Logo } from '@/components/ui/logo'
import { Landmark, Building2, Scale, BookText, BookOpen, CircleHelp, ShieldCheck, Undo2, MapPin, Phone, Mail } from 'lucide-react'
import { useTranslations } from 'next-intl'

export default function Footer() {
  const t = useTranslations('navigation.footer')

  return (
    <footer className="bg-stone-50 dark:bg-neutral-900 border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Information */}
          <div className="space-y-4">
            <Logo className="h-10" />
            <p className="text-sm text-muted-foreground max-w-xs">
              {t('companyDescription')}
            </p>
            <SocialIcons className="space-x-2" />
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-base font-semibold text-foreground">{t('quickLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  href="/tours"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <Landmark className="h-4 w-4" />
                  {t('allTours')}
                </Link>
              </li>
              <li>
                <Link
                  href="/agencies"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <Building2 className="h-4 w-4" />
                  {t('agencies')}
                </Link>
              </li>
              <li>
                <Link
                  href="/compare"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <Scale className="h-4 w-4" />
                  {t('comparePrice')}
                </Link>
              </li>
              <li>
                <Link
                  href="/blog"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <BookText className="h-4 w-4" />
                  {t('blog')}
                </Link>
              </li>
              <li>
                <Link
                  href="/about"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <BookOpen className="h-4 w-4" />
                  {t('aboutUs')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h3 className="text-base font-semibold text-foreground">{t('support')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  href="/help"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <CircleHelp className="h-4 w-4" />
                  {t('helpCenter')}
                </Link>
              </li>
              <li>
                <Link
                  href="/cancellation"
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2"
                >
                  <Undo2 className="h-4 w-4" />
                  {t('cancellationTerms')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-base font-semibold text-foreground">{t('contact')}</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-muted-foreground flex items-center gap-2">
                <MapPin className="h-4 w-4 text-muted-foreground" />
                {t('istanbul')}
              </li>
              <li className="text-muted-foreground flex items-center gap-2">
                <Phone className="h-4 w-4 text-muted-foreground" />
                +90 551 093 01 93
              </li>
              <li className="text-muted-foreground flex items-center gap-2">
                <Mail className="h-4 w-4 text-muted-foreground" />
                info@ziyareh.com
              </li>
            </ul>
            <div className="pt-4">
              <h4 className="text-sm font-medium mb-2">{t('paymentMethods')}</h4>
              <div className="flex items-center space-x-2">
                {/* Payment icons */}
                <div className="h-6 w-10 bg-gray-200 rounded"></div>
                <div className="h-6 w-10 bg-gray-200 rounded"></div>
                <div className="h-6 w-10 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t mt-10 pt-6 flex flex-col md:flex-row items-center justify-between text-sm text-muted-foreground">
          <p>{t('copyright')}</p>
          <div className="flex space-x-4 mt-4 md:mt-0">

            <Link href="/privacy" className="hover:text-foreground transition-colors">
            </Link>
            <span className="text-muted-foreground">{t('privacyPolicy')} | {t('termsOfUse')}</span>

            <Link href="/terms" className="hover:text-foreground transition-colors">
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}


